module.exports = __webpack_public_path__ + "img/9.6c33a38a.png";